export default "__VITE_PUBLIC_ASSET__cfb42135__"